import moment from 'moment'

export interface Range {
  end: moment.Moment
  start: moment.Moment
}

// The most recent COMPLETE calendar months — `months` of them, ending with last
// month. The month in progress is left out: a period that is still running
// cannot be read against a finished one without flattering or damning it.
export const lastCompleteMonths = (months: number): Range => ({
  end: moment().subtract(1, 'month').endOf('month'),
  start: moment().subtract(months, 'months').startOf('month'),
})

// "Previous Month" and its siblings mean the same window one span earlier, so
// both ranges cover the same number of days and can be compared directly.
export const shiftBack = ({ end, start }: Range, months: number): Range => ({
  end: end.clone().subtract(months, 'months'),
  start: start.clone().subtract(months, 'months'),
})
